export const labelWidth = sheet => {
  const {width, leftMargin, rightMargin, columns, columnGutter} = sheet
  let value = (
    (width - leftMargin - rightMargin - (columns - 1) * columnGutter) /
    columns
  ).toPrecision(4)
  return parseFloat(value)
}

export const labelHeight = sheet => {
  const {height, topMargin, bottomMargin, rows, rowGutter} = sheet
  let value = ((height - topMargin - bottomMargin - (rows - 1) * rowGutter) / rows).toPrecision(4)
  return parseFloat(value)
}

export const getResolutionFactore = type => {
  switch (type) {
    case 'in':
      return 96
    case 'mm':
      return 3.7795275591
    default:
      return 96
  }
}
